import "core-js/modules/es.array.push.js";
import "core-js/modules/es.iterator.constructor.js";
import "core-js/modules/es.iterator.map.js";
import custom from './custom.vue';
import bulletinBoard from './bulletinBoard.vue';
import { addTemplate } from './request';
export default {
  components: {
    custom,
    bulletinBoard
  },
  data() {
    return {
      activeKey: -1,
      timer1: '',
      timer2: '',
      dashboardFrontPage: false,
      dashboardDataBoard: false,
      frontPage: {},
      bulletinBoardList: {},
      delList: []
    };
  },
  created() {
    this.$nextTick(() => {
      this.dashboardFrontPage = this.isAuth('home.dashboardFrontPage');
      this.dashboardDataBoard = this.isAuth('home.dashboardDataBoard');
      this.activeKey = this.dashboardFrontPage ? 1 : 2;
    });
  },
  methods: {
    delArrFun(val) {
      this.delList.push(val);
    },
    setObjFun(type, val) {
      this.bulletinBoardList[type] = val;
    },
    setItem() {
      this.frontPage = {
        panelList: this.$refs.customRef.panelList,
        previewList: this.$refs.customRef.previewList
      };
    },
    tabChange(val) {
      if (this.activeKey == 1) {
        this.frontPage = {
          panelList: this.$refs.customRef.panelList,
          previewList: this.$refs.customRef.previewList
        };
      }
      setTimeout(() => {
        this.activeKey = val;
        if (val == 1) {
          this.timer1 = new Date().getTime();
        } else if (val == 2) {
          this.timer2 = new Date().getTime();
        }
      }, 400);
    },
    jumpFun() {
      if (this.dashboardFrontPage) {
        this.$message.error(this.$t('需要完善首页数据'));
        this.tabChange(1);
      }
    },
    jumpFun2() {
      if (this.dashboardDataBoard) {
        this.tabChange(2);
      } else {
        this.$message.success(this.$t('保存成功'));
      }
    },
    jumpFun3() {
      this.$message.success(this.$t('保存成功'));
    },
    async onSubmit() {
      //首页数据
      let frontPageArr = [];
      if (this.dashboardFrontPage) {
        this.frontPage.previewList.map(item => {
          if (item && item.panelId) {
            frontPageArr.push(item);
          }
        });
        if (frontPageArr.length == 0) {
          return this.$message.error(this.$t('首页至少要配置一个'));
        }
      }
      let arr = [];
      if (this.dashboardDataBoard && this.$refs.bulletinBoardRef) {
        const bulletinBoardList = this.bulletinBoardList;
        //看板数据
        for (let i in bulletinBoardList) {
          // if ( this.bulletinBoardList[i].previewList.length != 0) {
          for (let j = 0; j < bulletinBoardList[i].previewList.length; j++) {
            if (bulletinBoardList[i].previewList[j]) {
              bulletinBoardList[i].previewList[j].queryMethod = bulletinBoardList[i].queryMethod;
              bulletinBoardList[i].previewList[j].timeFrame = bulletinBoardList[i].timeFrame;
              arr.push(bulletinBoardList[i].previewList[j]);
            }
          }
        }
      }
      console.log({
        data: frontPageArr.concat(arr),
        delList: this.delList
      }, 22222);
      await addTemplate({
        data: frontPageArr.concat(arr),
        delList: this.delList
      });
      window.scrollTo(0, 0);
      this.$message.success(this.$t('保存成功'));
    }
  }
};